import { Dialog } from "@headlessui/react";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";

function GeneralActionButtonsModal({
  title,
  description,
  descriptionWithBoldStyle,
  dialogState,
  setDialogState,
  dialogOnClose = () => null,
  showCloseButton = false,
  enablePrimaryButton = true,
  primaryButtonText = "Yes",
  primaryButtonDisabled = false,
  primaryButtonAction = () => setDialogState(false),
  enableSecondaryButton = true,
  secondaryButtonText = "No",
  secondaryButtonDisabled = false,
  secondaryButtonAction = () => setDialogState(false),
}) {
  return (
    <Dialog open={dialogState} onClose={dialogOnClose} className="ui-dialogs">
      <DialogBackdrop />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className="ui-default-dialog ui-default-dialog-vertical-center"
        >
          <Dialog.Title className="font-body text-xl font-bold text-left mb-6">
            {title}
          </Dialog.Title>
          {showCloseButton && (
            <button className="ui-default-dialog-close" onClick={dialogOnClose}>
              <svg
                className="ui-icon h-3.5 w-3.5"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-close"></use>
              </svg>
            </button>
          )}
          <hr />
          {descriptionWithBoldStyle && (
            <div className="font-bold">{descriptionWithBoldStyle}</div>
          )}
          {description && (
            <div className="grid grid-cols-1 pt-4">{description}</div>
          )}
          <div className="grid grid-cols-2 mt-6">
            {enableSecondaryButton && (
              <button
                className="ui-btn-secondary xl:text-lg"
                disabled={secondaryButtonDisabled}
                onClick={secondaryButtonAction}
              >
                {secondaryButtonText}
              </button>
            )}
            {enablePrimaryButton && (
              <button
                className="ui-btn-primary xl:text-lg"
                disabled={primaryButtonDisabled}
                onClick={primaryButtonAction}
              >
                {primaryButtonText}
              </button>
            )}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default GeneralActionButtonsModal;
